import  { useEffect, type RefObject } from "react";

type HtmlElementRef = RefObject<HTMLElement | null>;

const useClickOutside = (ref: HtmlElementRef,  callback: () => void , triggerRef?: HtmlElementRef) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }

      if (triggerRef?.current && triggerRef.current.contains(event.target as Node)) {
        return;
      }

      callback();
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
};

export { useClickOutside };
